import { COLORS2 } from '@/Client/Styles';
import { SVGProps } from 'react';

export type IconProps = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};

export const KaiIcon = ({
  color = 'currentColor',
  size = 25,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 26 26' fill='none' {...props}>
    <path
      d='M25.0804 16.896V11.252L13.9194 0H11.1471L0.00596632 11.232V16.876L12.5332 4.246L25.0804 16.896ZM0 25.018H25.0784V21.122H0V25.018Z'
      fill={color}
    />
  </svg>
);

export const LegacyKaiIcon = ({
  color = 'currentColor',
  size = 25,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 25 25' fill='none' {...props}>
    <g clipPath='url(#clip0_8442_70825)'>
      <path
        d='M0.0307174 16.0126C0.0222069 15.8694 0.00859016 15.7246 0.00688807 15.5814C0.00518597 14.1444 0.0136964 12.7058 7.96949e-05 11.2689C-0.00332449 10.9451 0.102205 10.7091 0.340498 10.4813C3.84851 7.12567 7.34631 3.76033 10.8577 0.409625C11.0075 0.266419 11.2713 0.170406 11.4875 0.160642C12.1803 0.129722 12.8764 0.136232 13.5709 0.159015C13.7479 0.165524 13.9658 0.243636 14.09 0.362433C16.5206 2.67652 18.941 5.00036 21.3613 7.32584C22.5018 8.42104 23.6405 9.51787 24.7672 10.6245C24.883 10.7384 24.9885 10.9223 24.9902 11.0752C25.0055 12.6749 24.9987 14.2746 24.997 15.8759C24.997 15.928 24.9783 15.9801 24.9545 16.1119C24.786 15.9801 24.643 15.8873 24.5238 15.7734C20.5988 12.0126 16.6721 8.2518 12.7573 4.48287C12.5003 4.23551 12.3726 4.34617 12.182 4.52843C8.27055 8.28272 4.35403 12.0337 0.43922 15.7864C0.343902 15.8792 0.241777 15.9654 0.141353 16.0549C0.103907 16.0403 0.0681634 16.0272 0.0307174 16.0126Z'
        fill='white'
      />
      <path
        d='M12.4926 21.6751C16.4162 21.6751 20.3399 21.6751 24.2635 21.6751C25.0931 21.6751 24.9859 21.5969 24.9892 22.333C24.9942 23.1324 24.9725 23.9319 24.9993 24.7298C25.011 25.0647 24.882 25.1384 24.5216 25.1384C18.7694 25.1296 13.0155 25.1325 7.2633 25.1325C5.01571 25.1325 2.76645 25.1237 0.518864 25.1399C0.11326 25.1428 -0.0107682 25.0352 0.000964116 24.6812C0.0277809 23.833 0.031133 22.9849 0.000964116 22.1368C-0.0141203 21.7489 0.146781 21.6663 0.555737 21.6677C4.53468 21.6795 8.51531 21.6751 12.4943 21.6751H12.4926Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_8442_70825'>
        <rect width='25' height='25' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const KaiWhiteIcon = ({
  color = 'currentColor',
  size = 53,
  ...props
}: IconProps) => (
  <svg width={size} height={(size * 25) / 53} viewBox='0 0 53 25' {...props}>
    <g transform='matrix(1,0,0,1,-38.6267,-4.36875e-08)'>
      <g transform='matrix(0.581395,0,0,0.581395,0,0)'>
        <path
          d='M131.422,24.104L131.422,14.83C131.422,10.241 128.92,7.148 124.3,6.119C120.964,5.377 117.745,5.643 114.796,7.527C112.432,9.038 111.092,11.224 110.751,14.012C110.607,15.18 110.778,15.06 109.543,15.066C108.01,15.071 106.475,15.036 104.942,15.082C104.257,15.101 104.089,14.841 104.141,14.213C104.52,9.55 106.559,5.805 110.385,3.1C113.862,0.642 117.826,-0.125 122.004,0.016C125.023,0.116 127.966,0.601 130.704,1.985C134.159,3.731 136.26,6.544 137.281,10.235C137.809,12.144 138.01,14.088 138.012,16.057C138.023,21.426 138.012,26.799 138.02,32.168C138.02,32.639 138.031,33.121 138.126,33.582C138.519,35.523 140.032,36.566 142.25,36.46C143.218,36.415 143.701,36.89 143.701,37.887C143.701,39.219 143.693,40.549 143.707,41.881C143.709,42.265 143.639,42.55 143.2,42.612C140.013,43.072 136.962,42.801 134.341,40.722C132.307,39.108 131.527,36.828 131.473,34.326C131.4,30.92 131.454,27.513 131.454,24.107L131.419,24.107L131.422,24.104Z'
          fill='white'
        />
      </g>
      <g transform='matrix(0.581395,0,0,0.581395,0,0)'>
        <path
          d='M102.917,1.113C102.684,1.383 102.554,1.554 102.402,1.703C96.05,8.045 89.692,14.383 83.34,20.728C82.265,21.8 82.3,21.521 83.334,22.555C89.489,28.713 95.657,34.857 101.826,41.003C102.205,41.383 102.619,41.726 103.017,42.087C102.993,42.154 102.966,42.222 102.941,42.287C102.717,42.306 102.495,42.341 102.27,42.341C99.743,42.344 97.217,42.363 94.691,42.322C94.312,42.317 93.843,42.13 93.575,41.865C89.679,38.009 85.809,34.126 81.932,30.254C79.936,28.261 77.946,26.268 75.929,24.297C75.574,23.95 75.42,23.603 75.433,23.11C75.463,22.095 75.411,21.08 75.46,20.064C75.476,19.739 75.612,19.341 75.834,19.117C81.723,13.206 87.632,7.313 93.548,1.429C93.751,1.226 94.082,1.04 94.352,1.037C97.036,1.007 99.722,1.018 102.405,1.023C102.513,1.023 102.622,1.059 102.912,1.11L102.917,1.113Z'
          fill='white'
        />
      </g>
      <g transform='matrix(0.581395,0,0,0.581395,0,0)'>
        <path
          d='M128.216,16.374L128.216,17.977C128.216,18.992 128.194,20.008 128.224,21.023C128.24,21.532 128.053,21.711 127.555,21.811C123.621,22.602 119.686,23.395 115.768,24.259C114.249,24.595 112.792,25.163 111.511,26.095C109.535,27.532 108.982,29.52 109.318,31.832C109.648,34.123 111.067,35.512 113.201,36.143C116.537,37.129 119.876,36.847 123.109,35.713C124.709,35.149 126.196,34.256 127.734,33.514C127.847,33.46 127.964,33.408 128.134,33.33C128.167,33.538 128.21,33.687 128.213,33.833C128.218,35.436 128.235,37.039 128.197,38.64C128.191,38.9 127.996,39.252 127.78,39.393C123.366,42.276 118.589,43.487 113.347,42.428C110.052,41.762 107.16,40.367 104.929,37.765C101.04,33.23 101.428,24.459 108.628,21.001C110.943,19.888 113.366,19.122 115.871,18.629C119.697,17.874 123.537,17.186 127.373,16.474C127.609,16.431 127.853,16.414 128.218,16.371L128.216,16.374Z'
          fill='white'
        />
      </g>
      <g transform='matrix(0.581395,0,0,0.581395,0,0)'>
        <path
          d='M149.526,21.369L149.526,1.741C149.526,0.836 149.526,0.836 150.403,0.834C152.028,0.834 153.652,0.853 155.274,0.823C155.84,0.812 156.003,1.015 156,1.568C155.986,14.79 155.986,28.012 156,41.234C156,41.783 155.846,41.992 155.277,41.981C153.609,41.951 151.938,41.949 150.27,41.981C149.664,41.995 149.512,41.783 149.512,41.201C149.531,34.592 149.523,27.979 149.523,21.369L149.526,21.369Z'
          fill='white'
        />
      </g>
      <g transform='matrix(0.581395,0,0,0.581395,0,0)'>
        <path
          d='M66.446,21.459L66.446,1.892C66.446,1.261 66.772,0.944 67.424,0.942C68.981,0.942 70.537,0.972 72.094,0.929C72.736,0.91 72.891,1.137 72.891,1.744C72.874,9.147 72.88,16.547 72.88,23.95L72.88,41.144C72.88,41.753 72.566,42.057 71.94,42.057C70.361,42.057 68.78,42.032 67.202,42.07C66.6,42.084 66.435,41.881 66.438,41.293C66.457,34.681 66.449,28.069 66.449,21.456L66.446,21.459Z'
          fill='white'
        />
      </g>
    </g>
  </svg>
);

export const PropertiesIcon = ({
  color = 'currentColor',
  size = 22,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='12 9 16 22' fill='none' {...props}>
    <path
      d='M20 10C16.134 10 13 13.134 13 17C13 21.25 20 30 20 30C20 30 27 21.25 27 17C27 13.134 23.866 10 20 10Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 19.5C21.3807 19.5 22.5 18.3807 22.5 17C22.5 15.6193 21.3807 14.5 20 14.5C18.6193 14.5 17.5 15.6193 17.5 17C17.5 18.3807 18.6193 19.5 20 19.5Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const MarketIcon = ({
  color = 'currentColor',
  size = 22,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='9 9 22 22' fill='none' {...props}>
    <path
      d='M20.0618 29.9987C14.5046 30.0346 9.99867 25.5044 10 20.0014C10.0013 14.4797 14.5112 9.98275 20.0312 10C25.5259 10.0174 29.9985 14.5036 30 20.0027C30 25.4565 25.5711 29.9654 20.0631 30L20.0618 29.9987Z'
      stroke={color}
      strokeWidth='0.94'
      strokeMiterlimit='10'
    />
    <path
      d='M10.6934 16.2328L11.9296 18.5751C12.2503 19.1247 12.7161 19.5519 13.3362 19.7462L16.188 20.6352C17.2473 20.9653 17.8408 22.0073 17.7676 23.08C17.7384 23.5165 17.9154 23.8692 18.2747 24.0648C18.8016 24.3509 19.0971 24.8833 19.0984 25.4795L19.1024 27.0659C19.1024 27.5703 19.5149 27.9562 19.966 28.0015C20.8803 28.092 21.0506 27.1843 21.1744 26.5322C21.3567 25.5753 21.9449 24.8088 22.8085 24.3736C23.438 24.0555 23.7254 23.5099 23.7693 22.8098C23.8359 21.7678 23.1119 20.7111 21.9662 20.7031L19.9274 20.6898C19.5575 20.6871 19.1902 20.5966 18.8695 20.4329L16.8321 19.3949C16.188 19.0662 15.9937 18.2344 16.2492 17.6461C16.5367 16.986 17.2646 16.6374 17.9606 16.8636L18.9627 17.191C19.141 17.2496 19.4098 17.183 19.4989 17.0393C19.5668 16.9288 19.6041 16.6214 19.5202 16.5202L18.7551 15.606C18.3106 15.0736 18.2986 14.3257 18.7564 13.7947L19.5908 12.8285C19.797 12.5889 19.9221 12.1684 19.7757 11.8689L18.9281 10.1309M28.9526 15.4529L26.6304 16.4896C26.1953 16.6839 26.0196 17.1524 26.0902 17.6102L26.846 19.9392C27.0017 20.2466 27.2373 20.4862 27.554 20.57L29.9933 21.2208'
      stroke={color}
      strokeMiterlimit='10'
    />
  </svg>
);

export const ContractorsIcon = ({
  color = 'currentColor',
  size = 22,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='10 11 20 14' fill='none' {...props}>
    <rect
      x='10.4004'
      y='21.6504'
      width='19'
      height='3'
      rx='1.5'
      stroke={color}
    />
    <path
      d='M11.3001 21.8171C11.3001 21.8171 10.8684 17.9578 12.2174 15.6529C13.2751 13.8459 15.0624 12.9284 15.7851 12.6164C15.9393 12.5498 16.1026 12.6645 16.1026 12.8325V16.1402C16.1026 16.5723 16.4529 16.9226 16.885 16.9226C17.3171 16.9226 17.6674 16.5723 17.6674 16.1402V11.2636C17.6674 11.2011 17.7181 11.1504 17.7806 11.1504H21.925C21.9875 11.1504 22.0381 11.2011 22.0381 11.2636V16.0592C22.0381 16.536 22.4247 16.9226 22.9015 16.9226C23.3783 16.9226 23.7649 16.536 23.7649 16.0592V12.875C23.7649 12.6965 23.9486 12.5825 24.1044 12.6697C24.8444 13.0836 26.6068 14.1999 27.4881 15.8673C28.6213 18.0114 28.5673 21.8171 28.5673 21.8171'
      stroke={color}
    />
  </svg>
);

export const CalendarIcon = ({
  color = 'currentColor',
  size = 24,
  ...props
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      x='3'
      y='5'
      width='18'
      height='17'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3 9H21'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7 3V7'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17 3V7'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7 13H7.01'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 13H12.01'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17 13H17.01'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7 17H7.01'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 17H12.01'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const EditRequestReviewIcon = ({
  color = 'currentColor',
  size = 20,
  ...props
}: IconProps) => (
  <svg
    width={size}
    height={(size * 19) / 20}
    viewBox='0 0 20 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0.589966 17.6297L1.38371 12.1829L13.7909 0.688477L18.59 5.33046L6.35831 16.8802L0.589966 17.6297Z'
      stroke={color}
    />
    <path d='M9.54858 3.86493L14.8427 9.15905' stroke={color} />
  </svg>
);

export const ProductsIcon = ({
  color = 'currentColor',
  size = 22,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='9 8 22 22' fill='none' {...props}>
    <path
      d='M9.86523 14.2788V10.1836C9.86523 9.07902 10.7607 8.18359 11.8652 8.18359H15.8335'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.896 28.1836H11.8008C10.6962 28.1836 9.80078 27.2882 9.80078 26.1836V22.2153'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M29.5469 22.0884V26.1836C29.5469 27.2882 28.6514 28.1836 27.5469 28.1836H23.5786'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M23.5142 8.18359H27.6094C28.7139 8.18359 29.6094 9.07902 29.6094 10.1836V14.1518'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14.8008 13.1367V23.0415'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.7207 13.1367V23.0415'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M21.0547 13.1367V23.0415'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M24.3887 13.1367V23.0415'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const TemplatesIcon = ({
  color = 'currentColor',
  size = 22,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='12 9 16 21' fill='none' {...props}>
    <rect
      x='12.998'
      y='11'
      width='14.0001'
      height='7.00047'
      rx='1'
      stroke={color}
      strokeLinejoin='round'
    />
    <path
      d='M25.9981 24.0022V22.002C25.9981 21.4497 25.5504 21.002 24.9981 21.002H14.998C14.4458 21.002 13.998 21.4497 13.998 22.002V24.0022'
      stroke={color}
    />
    <path d='M20 18V21.0002' stroke={color} />
    <rect
      x='22'
      y='24'
      width='8.00006'
      height='5.00033'
      rx='1'
      stroke={color}
      strokeLinejoin='round'
    />
    <rect
      width='8.00006'
      height='5.00033'
      rx='1'
      transform='matrix(-1 0 0 1 18 24)'
      stroke={color}
      strokeLinejoin='round'
    />
  </svg>
);

export const DashboardIcon = ({
  color = 'currentColor',
  size = 22,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='8 8 24 24' fill='none' {...props}>
    <rect
      x='10'
      y='10'
      width='8.57153'
      height='6'
      rx='1'
      stroke={color}
      strokeLinejoin='round'
    />
    <rect
      x='30'
      y='30'
      width='8.57153'
      height='6'
      rx='1'
      transform='rotate(-180 30 30)'
      stroke={color}
      strokeLinejoin='round'
    />
    <rect
      x='10'
      y='19'
      width='8.57153'
      height='11'
      rx='1'
      stroke={color}
      strokeLinejoin='round'
    />
    <rect
      x='30'
      y='21'
      width='8.57153'
      height='11'
      rx='1'
      transform='rotate(-180 30 21)'
      stroke={color}
      strokeLinejoin='round'
    />
  </svg>
);

export const UsersIcon = ({
  size = 22,
  color = 'currentColor',
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='10 10 20 16' fill='none' {...props}>
    <path
      d='M21.334 15.332C23.175 15.332 24.6675 16.8245 24.6675 18.6655C24.6675 20.2782 23.5222 21.6234 22.0007 21.9322'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18.666 15.332C16.825 15.332 15.3325 16.8245 15.3325 18.6655C15.3325 20.2782 16.4778 21.6234 17.9993 21.9322'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18 16.182C18 15.7126 18.3806 15.332 18.85 15.332H21.1502C21.6196 15.332 22.0002 15.7126 22.0002 16.182V25.9991H18V16.182Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.668 14.668C11.1951 14.668 10.0012 15.874 10.0012 17.3617C10.0012 18.6168 10.8511 19.6715 12.0013 19.9705'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.334 15.2097C15.334 14.9105 15.0852 14.668 14.7784 14.668H12.5561C12.2492 14.668 12.0005 14.9105 12.0005 15.2097V24.0016H15.334V22.2307'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <ellipse
      cx='1.66674'
      cy='1.66672'
      rx='1.66674'
      ry='1.66672'
      transform='matrix(-1 0 0 1 15.334 10)'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M27.334 14.668C28.8068 14.668 30.0008 15.874 30.0008 17.3617C30.0008 18.6168 29.1509 19.6715 28.0007 19.9705'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M24.668 15.2097C24.668 14.9105 24.9167 14.668 25.2235 14.668H27.4459C27.7527 14.668 28.0015 14.9105 28.0015 15.2097V24.0016H24.668V22.2307'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <ellipse
      cx='26.3347'
      cy='11.6667'
      rx='1.66674'
      ry='1.66672'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <ellipse
      cx='20.0001'
      cy='12.0001'
      rx='2.00009'
      ry='2.00007'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const LegacyPropertiesIcon = ({
  color = 'currentColor',
  size = 33,
  ...props
}: IconProps) => (
  <svg
    width={size}
    height={(size * 32) / 33}
    viewBox='0 0 33 32'
    fill='none'
    {...props}
  >
    <path
      d='M3.47059 18.7017C3.47059 20.5264 3.47059 28.8929 3.47059 31.0547H20.7647C20.7647 27.6576 20.7647 20.3223 20.7647 18.7017M1 21.1723L12.1176 10.0547L23.2353 21.1723M9.02941 31.0547V22.4076C10.8824 22.4076 12.7353 22.4076 15.2059 22.4076V31.0547'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.8955 7.22137C17.8955 8.14492 17.8955 10.6781 17.8955 13.0677M20.9954 16.1103H30.3399C30.3399 13.6658 30.3399 8.3875 30.3399 7.22137M16.1177 8.99915L24.1177 0.999146L32.1177 8.99915M21.8955 16.1103V9.88803C23.2288 9.88803 24.5621 9.88803 26.3399 9.88803V16.1103'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const LegacyMarketIcon = ({
  color = 'currentColor',
  size = 30,
  ...props
}: IconProps) => (
  <svg
    width={size}
    height={(size * 29) / 30}
    viewBox='0 0 30 29'
    fill='none'
    {...props}
  >
    <path
      d='M27.4444 15.8261L27.9404 15.7627L27.8998 15.4447L27.5938 15.3489L27.4444 15.8261ZM29 28L28.88 28.4854L29.5885 28.6605L29.496 27.9366L29 28ZM15 28H14.5C14.5 28.1561 14.5729 28.3033 14.6971 28.3978C14.8214 28.4924 14.9826 28.5235 15.1331 28.482L15 28ZM21.6111 26.1739L21.7311 25.6885L21.6041 25.6571L21.478 25.692L21.6111 26.1739ZM27.4444 15.8261L26.9485 15.8895L28.504 28.0634L29 28L29.496 27.9366L27.9404 15.7627L27.4444 15.8261ZM15 28H15.5V22.5H15H14.5V28H15ZM21.6111 14L21.4617 14.4772L27.2951 16.3033L27.4444 15.8261L27.5938 15.3489L21.7605 13.5228L21.6111 14ZM29 28L29.12 27.5146L21.7311 25.6885L21.6111 26.1739L21.4912 26.6593L28.88 28.4854L29 28ZM21.6111 26.1739L21.478 25.692L14.8669 27.518L15 28L15.1331 28.482L21.7442 26.6559L21.6111 26.1739Z'
      fill='currentColor'
    />
    <path
      d='M2.55556 15.8261L2.05959 15.7627L2.10022 15.4447L2.40618 15.3489L2.55556 15.8261ZM0.999999 28L1.11996 28.4854L0.41154 28.6605L0.504031 27.9366L0.999999 28ZM15 28H15.5C15.5 28.1561 15.4271 28.3033 15.3029 28.3978C15.1786 28.4924 15.0174 28.5235 14.8669 28.482L15 28ZM8.38889 26.1739L8.26893 25.6885L8.39592 25.6571L8.52201 25.692L8.38889 26.1739ZM2.55556 15.8261L3.05152 15.8895L1.49597 28.0634L0.999999 28L0.504031 27.9366L2.05959 15.7627L2.55556 15.8261ZM15 28H14.5V22.5H15H15.5V28H15ZM8.38889 14L8.53826 14.4772L2.70493 16.3033L2.55556 15.8261L2.40618 15.3489L8.23951 13.5228L8.38889 14ZM0.999999 28L0.880038 27.5146L8.26893 25.6885L8.38889 26.1739L8.50885 26.6593L1.11996 28.4854L0.999999 28ZM8.38889 26.1739L8.52201 25.692L15.1331 27.518L15 28L14.8669 28.482L8.25577 26.6559L8.38889 26.1739Z'
      fill='currentColor'
    />
    <path d='M21 26L21 14' stroke={color} />
    <path d='M9 26L9 14' stroke={color} />
    <path
      d='M21.3396 13.7064L15.0031 23L8.4906 13.4731C8.40803 13.3632 8.33123 13.2508 8.26022 13.136L8.22678 13.0871C7.44872 11.8664 7.02479 10.4587 7.00105 9.01707C6.97732 7.57542 7.35469 6.15493 8.09216 4.90993C8.82963 3.66493 9.899 2.64304 11.1841 1.9553C12.4691 1.26755 13.9208 0.940254 15.3812 1.00896C16.8417 1.07768 18.2551 1.53977 19.468 2.34503C20.6808 3.1503 21.6467 4.26793 22.2606 5.57651C22.8745 6.88509 23.1131 8.33456 22.9503 9.76744C22.7874 11.2003 22.2295 12.5618 21.3372 13.7039L21.3396 13.7064ZM15.0031 6.11416C14.4396 6.11416 13.8889 6.27892 13.4204 6.5876C12.9519 6.89628 12.5868 7.33502 12.3712 7.84834C12.1556 8.36165 12.0991 8.92649 12.2091 9.47143C12.319 10.0164 12.5903 10.5169 12.9887 10.9098C13.3871 11.3027 13.8947 11.5702 14.4473 11.6786C14.9999 11.787 15.5727 11.7314 16.0932 11.5188C16.6138 11.3061 17.0587 10.9461 17.3717 10.4841C17.6847 10.0221 17.8518 9.47899 17.8518 8.92338C17.8518 8.17833 17.5517 7.46379 17.0174 6.93696C16.4832 6.41013 15.7586 6.11416 15.0031 6.11416Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const LegacyContractorsIcon = ({
  color = 'currentColor',
  size = 24,
  ...props
}: IconProps) => (
  <svg
    width={size}
    height={(size * 20) / 24}
    viewBox='0 0 24 20'
    fill='none'
    {...props}
  >
    <path
      d='M10.3506 1.84994V0.999939H4.40059L1.00059 4.39994V6.94994L4.40059 5.24994H10.3506V3.54994'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.3504 1.84961H12.9004V4.39961H10.3504'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <rect
      width='1.7'
      height='4.25'
      transform='matrix(-1 0 0 1 14.6006 0.999939)'
      stroke={color}
      strokeWidth='0.85'
      strokeLinejoin='round'
    />
    <path
      d='M8.65098 5.25H6.10098L5.25098 18.85H9.50098L8.65098 5.25Z'
      stroke={color}
      strokeWidth='0.85'
      strokeLinejoin='round'
    />
    <path
      d='M20.5498 8.65039L20.5498 1.00039L17.9998 1.00039L17.9998 8.65039L19.2748 8.65039'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M23.0996 18.8496L15.4496 18.8496L15.4496 11.1996L23.0996 11.1996L23.0996 18.8496Z'
      stroke={color}
      strokeWidth='0.85'
      strokeLinejoin='round'
    />
    <path
      d='M20.5496 8.65039L23.0996 11.2004L15.4496 11.2004L17.9996 8.65039'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18 14.5996V18.8496'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
    />
    <path
      d='M19.7002 17.1504L19.7002 18.8504'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
    />
  </svg>
);

export const LegacyProductsIcon = ({
  color = 'currentColor',
  size = 25,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 25 25' fill='none' {...props}>
    <path d='M4 3.5V21.5' stroke={color} />
    <path d='M7 3.5V21.5' stroke={color} strokeWidth='2' />
    <path d='M10 3.5V21.5' stroke={color} />
    <path d='M13 3.5V21.5' stroke={color} strokeWidth='2' />
    <path d='M16 3.5V21.5' stroke={color} />
    <path d='M18 3.5V21.5' stroke={color} />
    <path d='M21 3.5V21.5' stroke={color} strokeWidth='2' />
    <path
      d='M21 1C22.1667 1 24.5 1 24.5 1C24.5 1.83333 24.5 4.5 24.5 4.5'
      stroke={color}
    />
    <path
      d='M4.5 24C3.33333 24 1 24 1 24C1 23.1667 1 20.5 1 20.5'
      stroke={color}
    />
    <path d='M1 4.5C1 3.33333 1 1 1 1C1.83333 1 4.5 1 4.5 1' stroke={color} />
    <path
      d='M24.5 20.5C24.5 21.6667 24.5 24 24.5 24C23.6667 24 21 24 21 24'
      stroke={color}
    />
  </svg>
);

export const LegacyTemplatesIcon = ({
  color = 'currentColor',
  size = 25,
  ...props
}: IconProps) => (
  <svg
    width={size}
    height={(size * 22) / 25}
    viewBox='0 0 25 22'
    fill='none'
    {...props}
  >
    <rect
      x='4.40039'
      y='0.99939'
      width='15.8667'
      height='7.93333'
      stroke={color}
      strokeWidth='1.13333'
      strokeLinejoin='round'
    />
    <path
      d='M19.1334 15.7334V12.3334H5.53345V15.7334'
      stroke={color}
      strokeWidth='1.13333'
    />
    <path d='M12.3342 8.9325V12.3325' stroke={color} strokeWidth='1.13333' />
    <rect
      x='14.6008'
      y='15.7328'
      width='9.06667'
      height='5.66667'
      stroke={color}
      strokeWidth='1.13333'
      strokeLinejoin='round'
    />
    <rect
      width='9.06667'
      height='5.66667'
      transform='matrix(-1 0 0 1 10.0676 15.7328)'
      stroke={color}
      strokeWidth='1.13333'
      strokeLinejoin='round'
    />
  </svg>
);

export const LegacyDashboardIcon = ({
  color = 'currentColor',
  size = 22,
  ...props
}: IconProps) => (
  <svg
    width={(size * 23) / 22}
    height={size}
    viewBox='0 0 23 22'
    fill='none'
    {...props}
  >
    <rect x='1' y='1' width='9' height='6' stroke={color} />
    <rect
      x='22'
      y='21'
      width='9'
      height='6'
      transform='rotate(-180 22 21)'
      stroke={color}
    />
    <rect x='1' y='10' width='9' height='11' stroke={color} />
    <rect
      x='22'
      y='12'
      width='9'
      height='11'
      transform='rotate(-180 22 12)'
      stroke={color}
    />
  </svg>
);

export const LegacyUsersIcon = ({
  size = 27,
  color = 'currentColor',
  ...props
}: IconProps) => (
  <svg
    width={size}
    height={(size * 22) / 27}
    viewBox='0 0 27 22'
    fill='none'
    {...props}
  >
    <path
      d='M15.4502 7.79901C17.7974 7.79901 19.7002 9.7018 19.7002 12.049C19.7002 14.1051 18.2401 15.8202 16.3002 16.214'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.0498 7.79901C9.70259 7.79901 7.7998 9.7018 7.7998 12.049C7.7998 14.1051 9.2599 15.8202 11.1998 16.214'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.2002 8.64901C11.2002 8.17957 11.5808 7.79901 12.0502 7.79901H15.4502C15.9196 7.79901 16.3002 8.17957 16.3002 8.64901V21.399H11.2002V8.64901Z'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.40039 6.94965C2.52262 6.94965 1.00039 8.48726 1.00039 10.384C1.00039 11.9843 2.08395 13.3289 3.55039 13.7101'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.80078 7.64027C7.80078 7.25885 7.48365 6.94965 7.09245 6.94965H4.25911C3.86791 6.94965 3.55078 7.25885 3.55078 7.64027V18.8496H7.80078V16.5918'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle
      cx='2.125'
      cy='2.125'
      r='2.125'
      transform='matrix(-1 0 0 1 7.80078 0.999451)'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M23.0999 6.94965C24.9776 6.94965 26.4999 8.48726 26.4999 10.384C26.4999 11.9843 25.4163 13.3289 23.9499 13.7101'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.6995 7.64027C19.6995 7.25885 20.0166 6.94965 20.4078 6.94965H23.2411C23.6323 6.94965 23.9495 7.25885 23.9495 7.64027V18.8496H19.6995V16.5918'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle
      cx='21.8245'
      cy='3.12445'
      r='2.125'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle
      cx='13.7502'
      cy='3.54939'
      r='2.55'
      stroke={color}
      strokeWidth='0.85'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const OrgSettingsIcon = ({
  color = 'currentColor',
  size = 22,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='9 11 22 16' fill='none' {...props}>
    <rect
      x='15.8505'
      y='11.665'
      width='3.85519'
      height='3.85519'
      rx='1.92759'
      stroke={color}
      strokeWidth='1.33'
      strokeLinecap='round'
    />
    <rect
      x='21.7763'
      y='18.333'
      width='3.85519'
      height='3.85519'
      rx='1.92759'
      stroke={color}
      strokeWidth='1.33'
      strokeLinecap='round'
    />
    <rect
      x='14.3681'
      y='24.2588'
      width='3.85519'
      height='3.85519'
      rx='1.92759'
      stroke={color}
      strokeWidth='1.33'
      strokeLinecap='round'
    />
    <path
      d='M10 26H14'
      stroke={color}
      strokeWidth='1.33'
      strokeLinecap='round'
    />
    <path
      d='M30.0003 26.665C30.3676 26.665 30.6653 26.3673 30.6653 26C30.6653 25.6327 30.3676 25.335 30.0003 25.335V26.665ZM18.1484 25.335V26.665H30.0003V25.335H18.1484Z'
      fill={color}
    />
    <path
      d='M10 13.5938H15.1852'
      stroke={color}
      strokeWidth='1.33'
      strokeLinecap='round'
    />
    <path
      d='M20.3711 13.5938L30.0007 13.5938'
      stroke={color}
      strokeWidth='1.33'
      strokeLinecap='round'
    />
    <path
      d='M30 20L26 20'
      stroke={color}
      strokeWidth='1.33'
      strokeLinecap='round'
    />
    <path
      d='M10 19.335C9.63273 19.335 9.335 19.6327 9.335 20C9.335 20.3673 9.63273 20.665 10 20.665V19.335ZM22 20.665V19.335H10V20.665V20.665ZM22 20.665C22.3673 20.665 22.665 20.3673 22.665 20C22.665 19.6327 22.3673 19.335 22 19.335V20.665Z'
      fill={color}
    />
  </svg>
);

const KAI_LOGO_WITH_NAME_ASPECT = 3.55813953;
export const KaiLogoWithName = (props: any) => (
  <svg
    width='156'
    height='43'
    viewBox='0 0 156 43'
    fill='none'
    {...{
      width: props.height
        ? props.height * KAI_LOGO_WITH_NAME_ASPECT
        : undefined,
      ...props,
    }}
  >
    <path
      d='M131.422 24.1043C131.422 21.0121 131.422 17.9225 131.422 14.8302C131.422 10.2406 128.92 7.1483 124.3 6.11935C120.964 5.37742 117.745 5.64278 114.796 7.52738C112.432 9.03832 111.092 11.2235 110.751 14.0125C110.607 15.1795 110.778 15.0604 109.543 15.0658C108.01 15.0712 106.475 15.036 104.942 15.082C104.257 15.101 104.089 14.8411 104.141 14.2129C104.52 9.55009 106.559 5.80524 110.385 3.10019C113.862 0.641536 117.826 -0.124761 122.004 0.0160423C125.023 0.11623 127.966 0.60092 130.704 1.98459C134.159 3.7311 136.26 6.54446 137.281 10.2351C137.809 12.1441 138.01 14.0883 138.012 16.0568C138.023 21.4263 138.012 26.7985 138.02 32.168C138.02 32.6392 138.031 33.1212 138.126 33.5815C138.519 35.523 140.032 36.5655 142.25 36.4599C143.218 36.4147 143.701 36.8904 143.701 37.8869C143.701 39.2191 143.693 40.5486 143.707 41.8808C143.709 42.2653 143.639 42.5496 143.2 42.6119C140.013 43.0722 136.962 42.8014 134.341 40.7219C132.307 39.1081 131.527 36.8281 131.473 34.3261C131.4 30.9198 131.454 27.5134 131.454 24.107C131.443 24.107 131.43 24.107 131.419 24.107L131.422 24.1043Z'
      fill='currentColor'
    />
    <path
      d='M102.917 1.11265C102.684 1.38343 102.554 1.55402 102.402 1.70295C96.05 8.04453 89.6922 14.3834 83.3398 20.7277C82.2648 21.8 82.3 21.5211 83.3344 22.5554C89.4891 28.7129 95.6574 34.8568 101.826 41.0034C102.205 41.3825 102.619 41.7264 103.017 42.0866C102.993 42.1543 102.966 42.2219 102.941 42.2869C102.717 42.3059 102.495 42.3411 102.27 42.3411C99.7434 42.3438 97.2171 42.3628 94.6907 42.3221C94.3116 42.3167 93.8432 42.1299 93.5751 41.8645C89.6787 38.0087 85.8093 34.1257 81.9317 30.2536C79.9361 28.2607 77.9459 26.2678 75.9286 24.2965C75.5739 23.9499 75.4196 23.6034 75.4331 23.1105C75.4629 22.0951 75.4114 21.0797 75.4602 20.0643C75.4764 19.7394 75.6118 19.3413 75.8339 19.1166C81.7232 13.2055 87.6316 7.31344 93.5481 1.42946C93.7511 1.22638 94.0815 1.03954 94.3523 1.03684C97.0357 1.00705 99.7218 1.01788 102.405 1.0233C102.513 1.0233 102.622 1.0585 102.912 1.10994L102.917 1.11265Z'
      fill='currentColor'
    />
    <path
      d='M0.0488666 27.3726C0.0353277 27.1344 0.0136656 26.8934 0.0109578 26.6551C0.00825008 24.2641 0.0217889 21.8705 0.000126782 19.4795C-0.00528875 18.9407 0.162593 18.548 0.54168 18.1689C6.12238 12.5855 11.6868 6.98587 17.273 1.41058C17.5112 1.1723 17.9309 1.01254 18.2748 0.996296C19.3769 0.944849 20.4844 0.95568 21.5891 0.993588C21.8707 1.00442 22.2173 1.13439 22.415 1.33206C26.2817 5.1825 30.1321 9.04919 33.9826 12.9186C35.7968 14.7409 37.6083 16.5659 39.4008 18.4072C39.5849 18.5968 39.7528 18.9027 39.7555 19.1573C39.7799 21.819 39.7691 24.4807 39.7664 27.1452C39.7664 27.2318 39.7366 27.3185 39.6987 27.5378C39.4306 27.3185 39.2032 27.1641 39.0136 26.9746C32.7695 20.717 26.5227 14.4593 20.2948 8.18812C19.886 7.77654 19.6829 7.96067 19.3796 8.26394C13.1572 14.5108 6.92659 20.7522 0.69873 26.9963C0.547095 27.1506 0.384629 27.2941 0.224871 27.443C0.1653 27.4187 0.108437 27.397 0.0488666 27.3726Z'
      fill='currentColor'
    />
    <path
      d='M128.216 16.3737C128.216 16.9586 128.216 17.4677 128.216 17.9767C128.216 18.9921 128.194 20.0076 128.224 21.023C128.24 21.532 128.053 21.7107 127.555 21.8109C123.621 22.6016 119.686 23.395 115.768 24.2588C114.249 24.5945 112.792 25.1631 111.511 26.0946C109.535 27.5324 108.982 29.5199 109.318 31.8324C109.648 34.1231 111.067 35.5122 113.201 36.1431C116.537 37.1288 119.876 36.8472 123.109 35.7126C124.709 35.1494 126.196 34.2558 127.734 33.5139C127.847 33.4597 127.964 33.4083 128.134 33.3298C128.167 33.5383 128.21 33.6872 128.213 33.8334C128.218 35.4364 128.235 37.0394 128.197 38.6397C128.191 38.8996 127.996 39.2516 127.78 39.3925C123.366 42.2762 118.589 43.4866 113.347 42.4279C110.052 41.7617 107.16 40.3673 104.929 37.7651C101.04 33.2296 101.428 24.4591 108.628 21.0013C110.943 19.8884 113.366 19.1221 115.871 18.6293C119.697 17.8738 123.537 17.1861 127.373 16.4739C127.609 16.4306 127.853 16.4144 128.218 16.371L128.216 16.3737Z'
      fill='currentColor'
    />
    <path
      d='M149.526 21.3694C149.526 14.8275 149.526 8.28281 149.526 1.74085C149.526 0.836458 149.526 0.836458 150.403 0.83375C152.028 0.83375 153.652 0.852704 155.274 0.822919C155.84 0.812088 156.003 1.01517 156 1.56755C155.986 14.7896 155.986 28.0116 156 41.2336C156 41.7833 155.846 41.9918 155.277 41.981C153.609 41.9512 151.938 41.9485 150.27 41.981C149.664 41.9945 149.512 41.7833 149.512 41.2011C149.531 34.5915 149.523 27.9791 149.523 21.3694H149.526Z'
      fill='currentColor'
    />
    <path
      d='M20.3084 35.7124C26.6473 35.7124 32.9862 35.7124 39.325 35.7124C40.6654 35.7124 40.4921 35.5689 40.4975 36.9201C40.5056 38.3877 40.4704 39.8553 40.5138 41.3202C40.5327 41.9349 40.3242 42.0703 39.742 42.0703C30.449 42.054 21.1532 42.0594 11.8602 42.0594C8.22906 42.0594 4.59524 42.0432 0.964127 42.073C0.308848 42.0784 0.108473 41.8807 0.127427 41.2309C0.170752 39.6739 0.176167 38.1169 0.127427 36.56C0.103057 35.8478 0.363003 35.6962 1.0237 35.6989C7.45193 35.7206 13.8829 35.7124 20.3111 35.7124H20.3084Z'
      fill='currentColor'
    />
    <path
      d='M66.446 21.4588C66.446 14.9358 66.446 8.41549 66.446 1.89248C66.446 1.26067 66.7718 0.943859 67.4235 0.942054C68.9805 0.942054 70.5374 0.97184 72.0944 0.928515C72.7361 0.909561 72.8905 1.13701 72.8905 1.74355C72.8742 9.14658 72.8796 16.5469 72.8796 23.9499C72.8796 29.6823 72.8796 35.4146 72.8796 41.1442C72.8796 41.7526 72.5664 42.0568 71.94 42.0568C70.3614 42.0568 68.7801 42.0324 67.2015 42.0703C66.6003 42.0838 66.4352 41.8808 66.4379 41.2932C66.4568 34.6808 66.4487 28.0685 66.4487 21.4561L66.446 21.4588Z'
      fill='currentColor'
    />
  </svg>
);

export const DeltaIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}: IconProps) => {
  const height = (size * Math.sqrt(3)) / 2;
  const centerX = size / 2;
  const topY = size - height;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill='none'
      {...props}
    >
      <path
        d={`M ${centerX} ${topY} L ${size} ${size} L 0 ${size} Z`}
        fill={color}
      />
    </svg>
  );
};

export const WarningDelta = (props: any) => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' {...props}>
    <g filter='url(#filter0_d_3940_1520)'>
      <path
        d='M8.95995 3.25443C9.31792 2.63441 10.2128 2.63441 10.5708 3.25443L17.417 15.1124C17.775 15.7324 17.3275 16.5074 16.6116 16.5074H2.91918C2.20324 16.5074 1.75578 15.7324 2.11375 15.1124L8.95995 3.25443Z'
        fill='url(#paint0_linear_3940_1520)'
      />
    </g>
    <path
      d='M10.6172 7.26542L10.3196 11.8505H9.41748L9.11987 7.26542H10.6172ZM9.13847 13.199C9.13847 12.7898 9.46398 12.455 9.86389 12.455C10.2731 12.455 10.6079 12.7898 10.6079 13.199C10.6079 13.6083 10.2731 13.9338 9.86389 13.9338C9.46398 13.9338 9.13847 13.6083 9.13847 13.199Z'
      fill='#1D1D1D'
    />
    <defs>
      <filter
        id='filter0_d_3940_1520'
        x='1.98779'
        y='2.78906'
        width='15.5552'
        height='14.7188'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='1' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_3940_1520'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_3940_1520'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_3940_1520'
        x1='9.76538'
        y1='14'
        x2='9.76538'
        y2='21.3901'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FDDB32' />
        <stop offset='1' stopColor='#97831E' />
      </linearGradient>
    </defs>
  </svg>
);

export const DirectionsIcon = ({
  color = 'currentColor',
  size = 40,
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 40 40' fill='none'>
    <path
      d='M26.6667 18.275L27.2557 17.6855L27.8458 18.275L27.2557 18.8645L26.6667 18.275ZM16.6667 25L15.8334 25L15.8334 21.0528L16.6667 21.0528L17.5001 21.0528L17.5001 25L16.6667 25ZM16.6667 21.0528L15.8334 21.0528C15.8334 20.5786 15.9268 20.109 16.1083 19.6709L16.8782 19.9898L17.6481 20.3087C17.5504 20.5446 17.5001 20.7975 17.5001 21.0528L16.6667 21.0528ZM16.8782 19.9898L16.1083 19.6709C16.2898 19.2328 16.5558 18.8347 16.8911 18.4993L17.4804 19.0886L18.0696 19.6779C17.8891 19.8584 17.7458 20.0728 17.6481 20.3087L16.8782 19.9898ZM17.4804 19.0886L16.8911 18.4993C17.2264 18.164 17.6245 17.898 18.0627 17.7165L18.3816 18.4864L18.7005 19.2563C18.4645 19.3541 18.2502 19.4973 18.0696 19.6779L17.4804 19.0886ZM18.3816 18.4864L18.0627 17.7165C18.5008 17.5351 18.9704 17.4417 19.4446 17.4417L19.4446 18.275L19.4446 19.1083C19.1892 19.1083 18.9364 19.1586 18.7005 19.2563L18.3816 18.4864ZM19.4446 18.275L19.4446 17.4417L26.6667 17.4417L26.6667 18.275L26.6667 19.1083L19.4446 19.1083L19.4446 18.275ZM26.6667 18.275L26.0777 18.8645L22.7999 15.5895L23.3889 15L23.9779 14.4105L27.2557 17.6855L26.6667 18.275ZM26.6667 18.275L27.2557 18.8645L23.9779 22.1395L23.3889 21.55L22.7999 20.9605L26.0777 17.6855L26.6667 18.275Z'
      fill={color}
    />
    <rect
      x='7.4751'
      y='20'
      width='18.2844'
      height='18.2844'
      transform='rotate(-45 7.4751 20)'
      stroke={color}
      strokeWidth='1.66667'
    />
  </svg>
);

export const ScopeIcon = ({
  color = 'currentColor',
  size = 20,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 15 19' fill='none' {...props}>
    <rect x='4.46155' y='0.5' width='5.92308' height='2.46154' stroke={color} />
    <path
      d='M10.5385 1.38464H14.3462V18.0001H0.5V1.38464H4.30769'
      stroke={color}
    />
    <path d='M3.5 7H11.5' stroke={color} />
    <path d='M3.5 10H11.5' stroke={color} />
    <path d='M3.5 13H11.5' stroke={color} />
  </svg>
);

export const ScopeReviewIcon = ({
  color = 'currentColor',
  size = 20,
  ...props
}: IconProps) => (
  <svg
    width={(size * 14) / 20}
    height={size}
    viewBox='0 0 14 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x='0.5' y='1.5' width='13' height='18' stroke={color} />
    <path d='M7 0L7 2.85714' stroke={color} />
    <path d='M1 6L14 6' stroke={color} />
    <path d='M10.619 0L10.619 2.85714' stroke={color} />
    <path d='M3 0L3 2.85714' stroke={color} />
  </svg>
);

const CHANGE_ORDER_ICON_RATIO = 17 / 22;
export const ChangeOrderIcon = ({
  color = 'currentColor',
  size = 22,
}: IconProps) => (
  <svg
    width={size}
    height={size * CHANGE_ORDER_ICON_RATIO}
    viewBox='0 0 22 17'
    fill='none'
  >
    <path
      d='M21.0811 16.25H0.918945L11 0.919922L21.0811 16.25Z'
      stroke={color}
    />
  </svg>
);

export const ChangeOrderReviewIcon = ({
  color = 'currentColor',
  size = 20,
  ...props
}: IconProps) => (
  <svg
    width={size}
    height={(size * 16) / 20}
    viewBox='0 0 20 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M19.0986 15.5H0.901367L10 0.942383L19.0986 15.5Z' stroke={color} />
  </svg>
);

export const CloseOutReviewIcon = ({
  color = 'currentColor',
  size = 20,
  ...props
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      x='0.707107'
      y='10'
      width='13.1421'
      height='13.1421'
      transform='rotate(-45 0.707107 10)'
      stroke={color}
    />
    <path d='M7.07104 10.1358L9.16618 12.4929L13.3564 7.77881' stroke={color} />
  </svg>
);

export const UploadIndicatorIcon = ({ size = 40, ...props }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect width='40' height='40' fill='#1D1D1D' />
    <g transform='rotate(180 20 20)'>
      <path
        d='M20 23.5L19.6146 23.8185L20 24.2848L20.3855 23.8185L20 23.5ZM25.84 17.2185L26.1585 16.8331L25.3877 16.196L25.0692 16.5814L25.4546 16.9L25.84 17.2185ZM20 6.99996L19.5 6.99996L19.5 23.5L20 23.5L20.5 23.5L20.5 6.99996L20 6.99996ZM14.5455 16.9L14.1601 17.2185L19.6146 23.8185L20 23.5L20.3855 23.1814L14.9309 16.5814L14.5455 16.9ZM20 23.5L20.3855 23.8185L25.84 17.2185L25.4546 16.9L25.0692 16.5814L19.6146 23.1814L20 23.5Z'
        fill='white'
      />
      <path d='M8 21.3V29H32V21.3' stroke='white' />
    </g>
  </svg>
);

export const PunchListIcon = ({
  color = 'currentColor',
  size = 20,
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 21 21' fill='none'>
    <circle cx='10.5' cy='10.5' r='10' stroke={color} />
    <path
      d='M6.21399 10.5514L13.3568 14.7858V10.5001V6.21436L6.21399 10.5514Z'
      stroke={color}
    />
  </svg>
);

export const ProgressIcon = ({
  color = 'currentColor',
  size = 20,
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 26 26' fill='none'>
    <rect
      x='0.707107'
      y='12.7279'
      width='17'
      height='17'
      transform='rotate(-45 0.707107 12.7279)'
      stroke={color}
    />
    <path d='M9 12.9013L11.6667 15.9013L17 9.90131' stroke={color} />
  </svg>
);

export const CancelIcon = ({
  color = 'currentColor',
  size = 24,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
    <circle cx='12' cy='12' r='10' stroke={color} strokeWidth='2' />
    <path
      d='M19.071 4.929L4.929 19.071'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
    />
  </svg>
);

export const WarningIcon = ({
  color = 'currentColor',
  size = 14,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill={color} {...props}>
    <path d='M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z' />
  </svg>
);

export const EyeIcon = ({
  color = 'currentColor',
  size = 14,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill={color} {...props}>
    <path d='M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z' />
    <path d='M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z' />
  </svg>
);

export const EditIcon = ({
  color = 'currentColor',
  size = 14,
  ...props
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill={color} {...props}>
    <path d='M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z' />
  </svg>
);

const OUT_OF_STOCK_ICON_RATIO = 17 / 19;
export const OutOfStockIcon = ({
  color = 'currentColor',
  size = 19,
  ...props
}: IconProps) => (
  <svg
    width={size}
    height={size * OUT_OF_STOCK_ICON_RATIO}
    viewBox='0 0 19 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
    {...props}
  >
    <path d='M0 0.5H2.53532L4.81712 12.2138H15.1105' stroke={color} />
    <path d='M18 1.31201L16.5295 9.12123H4.15713' stroke={color} />
    <path
      d='M6.49129 13.7781C7.11106 13.7783 7.61336 14.2812 7.61336 14.9011C7.61317 15.5209 7.11094 16.023 6.49129 16.0232C5.87143 16.0232 5.36843 15.521 5.36824 14.9011C5.36824 14.2811 5.87131 13.7781 6.49129 13.7781Z'
      stroke={color}
    />
    <path
      d='M13.6911 13.7781C14.3108 13.7783 14.8131 14.2812 14.8131 14.9011C14.8129 15.5209 14.3107 16.023 13.6911 16.0232C13.0712 16.0232 12.5682 15.521 12.568 14.9011C12.568 14.2811 13.0711 13.7781 13.6911 13.7781Z'
      stroke={color}
    />
    <path d='M8.16299 1.31201L12.1688 5.31804' stroke={color} />
    <path d='M8.16299 5.31805L12.1688 1.31203' stroke={color} />
  </svg>
);

export const AllIcons = {
  kai: KaiIcon,
  warningDelta: WarningDelta,
  kaiWhite: KaiWhiteIcon,
  properties: PropertiesIcon,
  market: MarketIcon,
  contractors: ContractorsIcon,
  outOfStock: OutOfStockIcon,
  products: ProductsIcon,
  templates: TemplatesIcon,
  dashboard: DashboardIcon,
  users: UsersIcon,
  calendar: CalendarIcon,
  delta: DeltaIcon,
  editRequestReview: EditRequestReviewIcon,
  scopeReview: ScopeReviewIcon,
  changeOrderReview: ChangeOrderReviewIcon,
  closeOutReview: CloseOutReviewIcon,
  uploadIndicator: UploadIndicatorIcon,
};

export const KaiHelpChatIcon = ({
  color = COLORS2.alwaysDark.darkerGray,
  size = 32,
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 34 34' fill='none'>
    <path
      d='M2 25.5116V1H32V25.5116H20.4822L9.64634 32V25.5116H2Z'
      stroke={color}
    />
    <path d='M11 13.5L17 7L23.5 13.5' stroke='white' />
    <path d='M11 18L23 18' stroke='white' />
  </svg>
);

export const LargeContractorIcon = ({
  color = 'currentColor',
  size = 41,
}: IconProps) => (
  <svg
    width={size}
    height={(size * 34) / 41}
    viewBox='0 0 41 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.4238 2.03859V0.500065H6.65418L0.500095 6.65415V11.2697L6.65418 8.19267H17.4238V5.11563'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.4235 2.03791H22.0391V6.65347H17.4235'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <rect
      width='3.07704'
      height='7.69261'
      transform='matrix(-1 0 0 1 25.1162 0.5)'
      stroke={color}
      strokeLinejoin='round'
    />
    <path
      d='M14.3482 8.19269H9.73263L8.19411 32.809H15.8867L14.3482 8.19269Z'
      stroke={color}
      strokeLinejoin='round'
    />
    <path
      d='M35.8848 14.3474L35.8848 0.500715L31.2692 0.500715L31.2692 14.3474L33.577 14.3474'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M40.5 32.808L26.6533 32.808L26.6533 18.9614L40.5 18.9614L40.5 32.808Z'
      stroke={color}
      strokeLinejoin='round'
    />
    <path
      d='M35.8844 14.3474L40.5 18.963L26.6533 18.963L31.2689 14.3474'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M31.2695 25.1153V32.8079' stroke={color} strokeLinecap='round' />
    <path
      d='M34.3477 29.7323L34.3477 32.8094'
      stroke={color}
      strokeLinecap='round'
    />
  </svg>
);

export const CameraIconSolid = ({
  color = 'currentColor',
  size = 24,
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
    <path
      d='M16.2969 6.10156H21.2812L23 8.2041V17.8057L21.2812 20H2.71875L1 17.8057V8.2041L2.71875 6.10156H7.41113L8.11621 4H15.5928L16.2969 6.10156ZM12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9Z'
      fill={color}
    />
  </svg>
);

export const CameraIconOutline = ({
  color = 'currentColor',
  size = 24,
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
    <ellipse
      cx='12.1054'
      cy='12.7157'
      rx='4.10537'
      ry='4.10537'
      stroke={color}
    />
    <path
      d='M16.2967 6.04304H21.2813L23 8.08797V17.4236L21.2813 19.5574H2.71869L1 17.4236V8.08797L2.71869 6.04304H7.41139L8.11575 4H15.5924L16.2967 6.04304Z'
      stroke={color}
    />
  </svg>
);

export const TaskIconOutline = ({
  color = 'currentColor',
  size = 24,
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
    <path
      d='M16.25 3H20.5V22H4.5V3H8.75V2H16.25V3ZM5.5 21H19.5V4H16.25V5.75H8.75V4H5.5V21ZM17.3799 9.3252L11.3799 16.3252L11 16.7686L10.6201 16.3252L7.62012 12.8252L8.37988 12.1748L11 15.2314L16.6201 8.6748L17.3799 9.3252ZM9.75 4.75H15.25V3H9.75V4.75Z'
      fill={color}
    />
  </svg>
);

export const TaskIconSolid = ({
  color = 'currentColor',
  size = 24,
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
    <path
      d='M16.25 4H20V21H5V4H8.75V2H16.25V4ZM11 15.2314L8.37988 12.1748L7.62012 12.8252L10.6201 16.3252L11 16.7686L11.3799 16.3252L17.3799 9.3252L16.6201 8.6748L11 15.2314ZM9.75 4.75H15.25V3H9.75V4.75Z'
      fill={color}
    />
  </svg>
);

export const NotesIconOutline = ({
  color = 'currentColor',
  size = 24,
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
    <path d='M14 20.5H5V4H19V15M14 20.5L19 15M14 20.5V15H19' stroke={color} />
  </svg>
);

export const NotesIconSolid = ({
  color = 'currentColor',
  size = 24,
}: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
    <path
      d='M13.5 14.5L13.5 21L4.5 21L4.5 3.5L19.5 3.5L19.5 14.5L13.5 14.5ZM14.5 20.6934L14.5 15.5L19.2217 15.5L14.5 20.6934Z'
      fill={color}
    />
  </svg>
);

export const TrashIcon = ({ color = 'currentColor', size = 40 }: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 40 40' fill='none'>
    <path
      d='M11.3999 14.2H28.5999M13.2999 14.2V27C13.294 27.5221 13.4862 28.0271 13.8379 28.413C14.0116 28.6002 14.2225 28.7491 14.457 28.8502C14.6915 28.9512 14.9445 29.0023 15.1999 29H24.7999C25.0488 28.9958 25.2943 28.9416 25.5219 28.8408C25.7495 28.74 25.9545 28.5945 26.1249 28.413C26.4922 28.0342 26.6983 27.5277 26.6999 27V14.2M17.9999 19.6L19.9999 21.6M19.9999 21.6L21.9999 23.6M19.9999 21.6L21.9999 19.6M19.9999 21.6L17.9999 23.6M17.3999 14.2V11.9C17.3934 11.6693 17.4684 11.4438 17.6119 11.263C17.684 11.178 17.7743 11.1103 17.8761 11.0648C17.9778 11.0193 18.0885 10.9971 18.1999 11H21.7999C21.9112 10.9971 22.0217 11.0192 22.1233 11.0647C22.2249 11.1102 22.315 11.178 22.3869 11.263C22.5311 11.4434 22.6066 11.6692 22.5999 11.9V14.2'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const LockIcon = ({ color = 'currentColor', size = 24 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect x='6' y='9.85714' width='12' height='10.2857' stroke={color} />
    <path d='M12 12.8571V17.5714' stroke={color} />
    <g clipPath='url(#clip0_350_4)'>
      <rect
        x='7.71436'
        y='3'
        width='8.57143'
        height='15.4286'
        rx='4'
        stroke={color}
      />
    </g>
    <defs>
      <clipPath id='clip0_350_4'>
        <rect width='12' height='9' fill='white' transform='translate(6 1)' />
      </clipPath>
    </defs>
  </svg>
);
